import { useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { API, errMsg } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await API.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <Logo />
        <h1 className="mt-10 font-serif text-3xl font-bold tracking-tight">Reset your password</h1>
        {sent ? (
          <div className="mt-6 bg-success/10 border border-success/30 text-success text-sm px-4 py-3 rounded-md" data-testid="forgot-success">
            If an account exists for {email}, a reset link has been sent. Please check your email.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-5">
            {error && <div className="bg-destructive/10 border border-destructive/30 text-destructive text-sm px-4 py-3 rounded-md" data-testid="forgot-error">{error}</div>}
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="forgot-email-input" type="email" required
                value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
            </div>
            <Button type="submit" data-testid="forgot-submit-btn" disabled={loading} className="w-full">
              {loading ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}
        <p className="mt-6 text-sm text-muted-foreground">
          <Link to="/login" data-testid="back-to-login-link" className="text-primary hover:underline">← Back to log in</Link>
        </p>
      </div>
    </div>
  );
}
